import { X, FolderSync, MessageSquarePlus, MessageSquareText } from "lucide-react";

/**
 * 분야(프로젝트) 변경 확인 다이얼로그 (v3.5)
 * window.confirm(확인/취소) 대신 3가지 선택지를 제공한다:
 *   1) 변경하고 새 대화        — 분야 변경 + 대화 초기화
 *   2) 변경하고 기존 대화 유지 — 분야만 변경, 현재 대화 이어감
 *   3) 취소                    — 아무 것도 하지 않음
 */
export default function CustomerChangeDialog({
  open,
  targetLabel,
  onNewChat,
  onKeepChat,
  onCancel,
}: {
  open: boolean;
  targetLabel: string;
  onNewChat: () => void;
  onKeepChat: () => void;
  onCancel: () => void;
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      onClick={onCancel}
    >
      <div
        className="w-full max-w-sm rounded-xl bg-card p-4 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-3 flex items-center justify-between">
          <span className="flex items-center gap-1.5 font-semibold">
            <FolderSync className="h-4 w-4 text-[#0E1E2D]" /> 분야 변경
          </span>
          <button
            onClick={onCancel}
            aria-label="닫기"
            className="rounded-md p-1 text-muted-foreground hover:bg-muted"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <p className="mb-4 text-sm text-muted-foreground">
          분야를 <span className="font-semibold text-foreground">{targetLabel}</span>
          (으)로 변경합니다. 진행 중인 대화를 어떻게 할까요?
        </p>

        <div className="space-y-2">
          <button
            onClick={onNewChat}
            className="flex w-full items-center gap-2 rounded-lg bg-primary px-3 py-2.5 text-sm font-semibold text-primary-foreground"
          >
            <MessageSquarePlus className="h-4 w-4 shrink-0" />
            변경하고 새 대화
          </button>
          <button
            onClick={onKeepChat}
            className="flex w-full items-center gap-2 rounded-lg border border-border px-3 py-2.5 text-sm font-medium hover:bg-muted"
          >
            <MessageSquareText className="h-4 w-4 shrink-0" />
            변경하고 기존 대화 유지
          </button>
          <button
            onClick={onCancel}
            className="flex w-full items-center justify-center rounded-lg px-3 py-2.5 text-sm font-medium text-muted-foreground hover:bg-muted"
          >
            취소
          </button>
        </div>
      </div>
    </div>
  );
}
